import React from 'react';

import { getYears } from 'constants/common';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const YearSelect = ({
  label,
  variant = 'standard',
  field: { name = 'years', value },
  form: { errors, touched, setFieldValue = () => {} },
  omitFields = [],
  asyncErrors,
  margin = 'none',
  required = false,
  disabled = false,
  firstLoad = false,
}) => {
  const years = getYears();
  const filterOptions = generateFilterOptions('start', 'label');

  return (
    <Autocomplete
      id={name}
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label || ''}
      error={handleError(name, errors, touched, asyncErrors)}
      options={years.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option == value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      value={years.find((month) => month?.value == value) || ''}
    />
  );
};

export { YearSelect };
